import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=71ae3780&scoped=true&"
import script from "./SectionIntro.vue?vue&type=script&lang=js&"
export * from "./SectionIntro.vue?vue&type=script&lang=js&"
import style0 from "./SectionIntro.vue?vue&type=style&index=0&id=71ae3780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae3780",
  null
  
)

export default component.exports